export default class BlockSliderMultiple {
	constructor() {
		let blocks = document.querySelectorAll('.block-slider-multiple');

		blocks.forEach(block => {
			let swiper = block.querySelector(".swiper");
			const prev = swiper.querySelector(".button-prev");
			const next = swiper.querySelector(".button-next");
			new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});
		});
	}
}
